export default __webpack_public_path__ + "static/media/chair-blue.ff9f74cd.svg";